module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "input select"
  }, _vm._l((_vm.quests), function(quest) {
    return _c('option', {
      domProps: {
        "value": quest.slug,
        "textContent": _vm._s(quest.name)
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2e8bd33b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestSearch.vue
// module id = 136
// module chunks = 1